export default __webpack_public_path__ + "static/media/octopus-rain.24ac3d14.png";